import { render } from "./DoctorAccountTab.vue?vue&type=template&id=633b41a8"
import script from "./DoctorAccountTab.vue?vue&type=script&lang=js"
export * from "./DoctorAccountTab.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QBanner from 'quasar/src/components/banner/QBanner.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import QCheckbox from 'quasar/src/components/checkbox/QCheckbox.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBanner,QInput,QSelect,QCheckbox});
